export interface FundAttributionState {
  fundName: string;
  bmName: string;
  selectedAsOfDateStd: string;
  selectedGridDataType: string;
  periodDates: FundAttributionPeriodDates[];
  calendarYears: FundAttributionPeriodDates[];
  timePeriods: FundAttributionTimePeriods;
  showCurrencyAttribution: boolean;
  validSignIn: boolean;
  hasLoadedFullFeed?: boolean;
}

export interface FundAttributionPeriodDates {
  asOfDate: string;
  asOfDateStd: string;
  year?: string;
}

export interface FundAttributionTimePeriods {
  quarterly: FundAttributionGridDataTypes;
  twelveMonthRolling: FundAttributionGridDataTypes;
  ytd: FundAttributionGridDataTypes;
  calendarYear: FundAttributionGridDataTypes;
}

export interface FundAttributionGridDataTypes {
  regionsTotalData: FundAttributionTotalRegionGridData &
    FundAttributionOtherGridData;
  sectorsTotalData: FundAttributionTotalSectorGridData &
    FundAttributionOtherGridData;
}

export interface FundAttributionTotalRegionGridData {
  totalData: FundAttributionGridData;
  regions: (FundAttributionRegionGridData & FundAttributionOtherGridData)[];
}

export interface FundAttributionTotalSectorGridData {
  totalData: FundAttributionGridData;
  sectors: (FundAttributionSectorGridData & FundAttributionOtherGridData)[];
}

export interface FundAttributionRegionGridData {
  regionName: string;
  regionData: FundAttributionGridData;
  countries: (FundAttributionCountryGridData & FundAttributionOtherGridData)[];
  isExpanded?: boolean;
}

export interface FundAttributionCountryGridData {
  countryName: string;
  countryData: FundAttributionGridData;
}

export interface FundAttributionSectorGridData {
  sectorName: string;
  sectorData: FundAttributionGridData;
  industries: (FundAttributionIndustryGridData &
    FundAttributionOtherGridData)[];
  isExpanded?: boolean;
}

export interface FundAttributionIndustryGridData {
  industryName: string;
  industryData: FundAttributionGridData;
}

export interface FundAttributionGridData {
  portfolio: FundAttributionGridDataColumnsSet1;
  benchmark: FundAttributionGridDataColumnsSet1;
  variation: FundAttributionGridDataColumnsSet1;
  currency: FundAttributionGridDataColumnsSet2 & {
    totalCurrencyEffect: string;
  }; // 'Local' fields will be binded to it.
  attribution: FundAttributionGridDataColumnsSet2;
}

export interface FundAttributionGridDataColumnsSet1 {
  averageWeight: string;
  totalReturn: string;
  contributionToReturn: string;
}

export interface FundAttributionGridDataColumnsSet2 {
  allocationEffect: string;
  selectionEffect: string;
  interactionEffect: string;
  totalEffect: string;
}

export interface FundAttributionOtherGridData {
  asOfDate: string;
  asOfDateStd: string;
  levelNumber: string;
  numberOfMonths: string;
}

export enum FundAttributionTimePeriod {
  'QUARTERLY',
  'TWELVE_MONTH_ROLLING',
  'YTD',
  'CALENDAR_YEAR',
}

export interface FundAttributionCustomDataFetch {
  targetView: FundAttributionTimePeriod;
  selectedAsOfDateStd: string;
  selectedGridDataType: string;
  showCurrencyAttribution: boolean;
}

export interface FundAttributionDownloadableGridData {
  fundName: string;
  selectedAsOfDate: string;
  selectedSectorTotalData: FundAttributionTotalSectorGridData;
  selectedCountryTotalData: FundAttributionTotalRegionGridData;
}

export interface FundAttributionDownloadableTableFormat {
  classification: string; // Left only this field as non-optional, as others can be 'nulled' to make empty row in excel.
  portfolioAverageWeight?: string;
  portfolioTotalReturn?: string;
  portfolioContributionToReturn?: string;
  benchmarkAverageWeight?: string;
  benchmarkTotalReturn?: string;
  benchmarkContributionToReturn?: string;
  variationAverageWeight?: string;
  variationTotalReturn?: string;
  variationContributionToReturn?: string;
  currencyAllocationEffect?: string;
  currencySelectionEffect?: string;
  currencyInteractionEffect?: string;
  currencyTotalEffect?: string;
  currencyTotalCurrencyEffect?: string;
  attributionAllocationEffect?: string;
  attributionSelectionEffect?: string;
  attributionInteractionEffect?: string;
  attributionTotalEffect?: string;
}
